var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    _vm.tag,
    { tag: "component", staticClass: "hkl-hover-tooltip-outer" },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c("div", { staticClass: "tips-content-outer" }, [_vm._t("tips")], 2),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }